//Video Player
$(".js-overlay-start").unbind("click").bind("click", function (e) {
    e.preventDefault();
    var src = $(this).attr("data-url");
    var file = $(this).attr("data-source");
    $(".overlay-video").show();
    if(file == "interne") {
        $("#player").attr("sandbox");
    } else {
        $("#player").removeAttr("sandbox");
    }

    setTimeout(function () {
        $(".overlay-video").addClass("is-overlay");
        $("#player").attr("src", src);
    }, 100);
});

// video overlayer: close it if you click outside of the modal
$(".overlay-video").click(function (event) {
    if (!$(event.target).closest(".videoWrapperExt").length) {
        $("#player").attr("src", "");
        $(".overlay-video").removeClass("is-overlay");
        setTimeout(function () {
            $(".overlay-video").hide();
        }, 600);
    }
});

// video overlayer: close it via the X icon
$(".close").click(function (event) {
    $("#player").attr("src", "");
    $(".overlay-video").removeClass("is-overlay");
    setTimeout(function () {
        $(".overlay-video").hide();
    }, 600);

});
